// @flow

const tagRendererStyles = {
  // Container style
  tagsContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    // gap: '4px',
    alignItems: 'center',
    overflowX: 'auto',
    overflowY: 'hidden',
    // Thin scrollbar that only shows on hover
    '&::-webkit-scrollbar': {
      height: 4
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'transparent',
      borderRadius: 2
    },
    '&:hover::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0,0,0,0.3)'
    },
    // Firefox scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover': {
      scrollbarColor: 'rgba(0,0,0,0.3) transparent'
    }
  },
  
  // Legacy support for old styles
  chipTag: (theme) => ({
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    marginRight: 2,
    // height: 20
  }),

  hover: (theme) => ({
    cursor: 'pointer',
    '&:hover': {
      filter: 'brightness(95%)'
    }
  }),

  deleteIcon: (theme) => ({
    '&:hover': {
      color: `${theme.palette.primary.main} !important`
    }
  })
};

export default tagRendererStyles;